<template>
  <div class="square-list">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>广场内容管理</span>
        </div>
      </template>
      <el-table :data="squareList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="content" label="内容"></el-table-column>
        <el-table-column prop="like_count" label="点赞数" width="100"></el-table-column>
        <el-table-column prop="comment_count" label="评论数" width="100"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SquareList',
  data() {
    return {
      squareList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.fetchSquareList()
  },
  methods: {
    // 获取广场内容列表
    fetchSquareList() {
      try {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/content/square-list?page=${this.currentPage}&pageSize=${this.pageSize}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.squareList = data.data.list
            this.total = data.data.total
          }
        })
      } catch (error) {
        this.$message.error('获取广场内容列表失败')
      }
    },

    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchSquareList()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchSquareList()
    },

    // 删除广场内容
    handleDelete(id) {
      this.$confirm('确定要删除该广场内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/content/delete-square', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchSquareList()
          } else {
            this.$message.error(data.message)
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.square-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
